import { getCookie } from 'cookies-next';

export const oneTrust = {
  peformanceCookiesOptOut: 'C0002:0',
  targetingCookiesOptOut: 'C0004:0',
};

export const rejectedPerformanceCookies = () => {
  if (getCookie('OptanonConsent')?.includes(oneTrust.peformanceCookiesOptOut)) {
    if (getCookie('OptanonAlertBoxClosed')) {
      return true;
    }
  }
  return false;
};

export const rejectedTargetingCookies = () => {
  if (getCookie('OptanonConsent')?.includes(oneTrust.targetingCookiesOptOut)) {
    if (getCookie('OptanonAlertBoxClosed')) {
      return true;
    }
  }
  return false;
};

export const agreedToCookies = () => {
  if (rejectedPerformanceCookies() || rejectedTargetingCookies()) {
    return false;
  }
  return true;
};
